// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"c006754e","268":"93c4dacc","282":"f0a4a8ce","321":"53eb3e9e","397":"32a81307","538":"fca1611e","563":"184c28f7","668":"90c8daa6","780":"8913caa8","915":"d0332b73","968":"d141c8da"}[chunkId] + ".chunk.js";
};